module.exports = __webpack_public_path__ + "img/Store_Mobile.jpg";